module.exports = __webpack_public_path__ + "static/penny-mobile-216b2dd4780b44b0346a6ef53c4a39cc.jpg";